
import { ClientQueryStatusType } from './client-query';

export class ClientQueryStatusUpdate {
	public status: ClientQueryStatusType;
}
